'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactUtils = require('../../utils/reactUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarTableOpening = function (_React$Component) {
  _inherits(CalendarTableOpening, _React$Component);

  function CalendarTableOpening() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CalendarTableOpening);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalendarTableOpening.__proto__ || Object.getPrototypeOf(CalendarTableOpening)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      if (_this.props.onClick) {
        event.preventDefault();
        _this.props.onClick(_this.props.opening);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CalendarTableOpening, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          opening = _props.opening,
          target = _props.target;

      var classes = (0, _classnames2.default)('calendar-table__opening', {
        'calendar-table__opening--selected': opening.isSelected,
        'calendar-table__opening--old': opening.isOld
      });
      return _react2.default.createElement(
        'a',
        {
          href: opening.uri,
          target: target,
          title: opening.time.format('LLLL'),
          onClick: this.onClick,
          className: classes
        },
        _react2.default.createElement(
          'time',
          { dateTime: opening.time.format() },
          opening.time.format('LT')
        )
      );
    }
  }]);

  return CalendarTableOpening;
}(_react2.default.Component);

CalendarTableOpening.displayName = 'CalendarTableOpening';
CalendarTableOpening.propTypes = {
  opening: _reactUtils.openingShape.isRequired,
  target: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
exports.default = CalendarTableOpening;